
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/mntn",
      function () {
        return require("private-next-pages/destinations/mntn.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/mntn"])
      });
    }
  